import React from "react";

const Header = () => {
  return (
    <header className="bg-alert">
      <h1>Recetas de bebidas</h1>
      <h4>By: Anjrot</h4>
    </header>
  );
};

export default Header;
